import { render, staticRenderFns } from "./AccountHolderExpenseDistributionDetail.vue?vue&type=template&id=433e90bf&scoped=true"
import script from "./AccountHolderExpenseDistributionDetail.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseDistributionDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433e90bf",
  null
  
)

export default component.exports